export default __webpack_public_path__ + "static/media/ico_right_arrow_gray.576a9da8.svg";